import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import packageInfo from '../../../../package.json';
declare function validateConfig(config:any):any;
@Injectable({
  providedIn: 'root'
})
export class AppdataService {
  private appConfig = null;
  private configSubject: Subject<any>;
  private appLabels = null;
  private labelSubject: Subject<any>;
  private appVersion: string;
  
  constructor() {
    this.configSubject = new Subject();
    this.labelSubject = new Subject();
    this.appVersion = packageInfo.version;
  }

  /**
   * Get App Config
   */
  get appConfigSub(): Observable<any> {
    return this.configSubject.asObservable();
  }

  /**
   * App label contains all the static info messages used in the application
   */

  get appLabelSub(): Observable<any> {
    return this.labelSubject.asObservable();
  }

  setConfig(config: any) {
    let appConfig = config;
    try {      
      appConfig =  validateConfig(config);
    } catch {}
    this.appConfig = appConfig;
    this.configSubject.next(appConfig);
  }

  getConfig() {
    return { ...this.appConfig };
  }

  setLabels(labels: any) {
    this.appLabels = labels;
    this.labelSubject.next(labels);
  }

  getLabels() {
    return { ...this.appLabels };
  }

  /**
   * method to get app version
   * @returns app version as a string
   */
  getAppVersion(): string {
    return this.appVersion;
  }
}
